import { LoginClearPreloadedData } from '../login/types';
import * as Bixby from './../../core';

export interface ExportState {
  isLoading: boolean;
  error?: Bixby.Models.BixbyError;
}

export const EXPORT_INPROGRESS = 'EXPORT_INPROGRESS';
export const EXPORT_SUCCESS = 'EXPORT_SUCCESS';
export const EXPORT_FAILURE = 'EXPORT_FAILURE';

interface ExportInProgress extends Bixby.Models.BixbyAction<undefined, typeof EXPORT_INPROGRESS> {
  type: typeof EXPORT_INPROGRESS;
}

interface ExportSuccess extends Bixby.Models.BixbyAction<Blob, typeof EXPORT_SUCCESS> {
  type: typeof EXPORT_SUCCESS;
  payload: Blob;
}

interface ExportFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof EXPORT_FAILURE> {
  type: typeof EXPORT_FAILURE;
  payload: Bixby.Models.BixbyError;
}

export type ExportActionTypes = ExportInProgress | ExportSuccess | ExportFailure | LoginClearPreloadedData;
